module.exports = __webpack_public_path__ + "img/product_image.6e3154d8.svg";